export const PACKAGE_NAME = '@atlassian/jira-issue-field-status';

export const POPUP_KEYS = {
	recurWork: 'RECUR_WORK',
};

export type PopupKeys = (typeof POPUP_KEYS)[keyof typeof POPUP_KEYS];
